






































import { defineComponent } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseIcon from "@/components/BaseIcon";
import GroupList from "@/components/GroupList";

export default defineComponent({
  name: "MassMessageSelectView",
  components: { BaseButton, BaseIcon, GroupList, BaseCheckbox },
  props: {
    loading: { type: Boolean, required: true },
    allowContinue: { type: Boolean, required: true },
    groups: { type: Array as () => Group[], required: true },
    selectedGroupIds: { type: Array as () => string[], required: true },
    excludeGroupIds: { type: Array as () => string[], required: true },
    btnIsBottom: { type: Boolean, default: false },
  },
  methods: {
    onGroupSelect(status: boolean, groupId: string) {
      this.$emit("markGroup", status, groupId);
    },
    onExcludeGroupSelect(status: boolean, groupId: string) {
      this.$emit("markExcludedGroup", status, groupId);
    },
  },
});
